import { toast } from "react-toastify";

import type { TGraphQLError } from "settings/apollo/types";

export const showGraphQLErrorToasts = (graphQLErrors: readonly TGraphQLError[]): void => {
  graphQLErrors.forEach(error => {
    if (Array.isArray(error.fields) && error.fields.length) {
      error.fields.forEach(fieldError => toast.error(fieldError.translated_message ?? fieldError.message));
      return;
    }

    toast.error(error.translated_message ?? error.message);
  });
};
